/**
 * Copyright 2020, IntraLinks, Inc. All rights reserved.
 */
import React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { IlSelect, IlSelectItem } from 'il-framework-component';
import Logo from '../../../../assets/ssnc-intralinks-logo.svg';
import { I18nNamespaces } from '../../utils/constants.util';
import Styles from './Wrapper.scss';
import { setLocaleCookie } from '../../utils/helpers.util';
import { supportedLanguages } from '../../utils/profile.util';

interface WrapperProps extends WithTranslation {
  children: React.ReactNode;
}

const Wrapper: React.FC<WrapperProps> = ({ children, t, i18n }: WrapperProps) => (
  <div className={Styles.wrapper}>
    <div className={Styles.innerwrapper}>
      <div className={Styles.container}>
        <header role='banner' className={Styles.containerTop}>
          <img className={Styles.logo} alt='SS&C Intralinks' src={Logo} />
          <div className='language-select-container'>
            <IlSelect
              labelText='Language'
              hideLabel
              id='language-select'
              onChange={(e: React.ChangeEvent<HTMLInputElement>): void => {
                const lang = e.currentTarget.value;
                i18n.changeLanguage(lang).then(() => {
                  localStorage.setItem('selected-language', i18n.language);
                  setLocaleCookie(i18n.language);
                });
              }}
              value={i18n.language}
            >
              {
                Object.keys(supportedLanguages).map((lang) => (
                  <IlSelectItem
                    key={lang}
                    value={lang}
                    text={supportedLanguages[lang]}
                  />
                ))
              }
            </IlSelect>
          </div>
        </header>
        {children}
        <div className={Styles.footer}>
          <div className={Styles.copyright}>
            {`© ${new Date().getFullYear()}${t('logout.COPY_RIGHTS')}`}
          </div>
          <div className={Styles.legal}>
            <a href='https://www.intralinks.com/privacy' target='_blank' rel='noreferrer'>{t('logout.PRIVACY_POLICY')}</a>
            {' | '}
            <a href='https://www.intralinks.com/contact/client-services' target='_blank' rel='noreferrer'>{t('logout.NEED_HELP')}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default withTranslation(I18nNamespaces.DEFAULT)(Wrapper);
